import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILMATERIALCATEGORY,
  DELETE_CIVILMATERIALCATEGORY,
  UPDATE_CIVILMATERIALCATEGORY,
  ADD_NEW_CIVILMATERIALCATEGORY,
} from "./actionType";

import {
  getCivilAccountCategorySuccess,
  getCivilAccountCategoryFail,
  deleteCivilAccountCategorySuccess,
  deleteCivilAccountCategoryFail,
  updateCivilAccountCategorySuccess,
  updateCivilAccountCategoryFail,
  addCivilAccountCategorySuccess,
  addCivilAccountCategoryFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilAccountCategoryApi,
  updateCivilAccountCategoryApi,
  deleteCivilAccountCategoryApi,
  addNewCivilAccountCategoryApi,
  approveCivilAccountCategoryApi
} from "../../helpers/backend_helper";

function* getCivilAccountCategory({ payload: civilAccountCategory }) {
  try {
    const response = yield call(getCivilAccountCategoryApi, civilAccountCategory);
    yield put(getCivilAccountCategorySuccess(GET_CIVILMATERIALCATEGORY, response.data));
  } catch (error) {
    yield put(getCivilAccountCategoryFail(GET_CIVILMATERIALCATEGORY, error));
  }
}

function* onUpdateCivilAccountCategory({ payload: civilAccountCategory }) {
  try {
    if (civilAccountCategory.setApprove) {
      const response = yield call(approveCivilAccountCategoryApi, civilAccountCategory);
      yield put(updateCivilAccountCategorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilAccountCategoryApi, civilAccountCategory);
      yield put(updateCivilAccountCategorySuccess(response));
      toast.success(updateCivilAccountCategorySuccess.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilAccountCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilAccountCategory({ payload: civilAccountCategory }) {
  try {
    const response = yield call(deleteCivilAccountCategoryApi, civilAccountCategory);
    yield put(deleteCivilAccountCategorySuccess({ civilAccountCategory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilAccountCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilAccountCategory({ payload: civilAccountCategory }) {
  try {
    const response = yield call(addNewCivilAccountCategoryApi, civilAccountCategory);
    yield put(addCivilAccountCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilAccountCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilAccountCategory() {
  yield takeEvery(GET_CIVILMATERIALCATEGORY, getCivilAccountCategory);
}

export function* watchUpdateCivilAccountCategory() {
  yield takeEvery(UPDATE_CIVILMATERIALCATEGORY, onUpdateCivilAccountCategory);
}

export function* watchDeleteCivilAccountCategory() {
  yield takeEvery(DELETE_CIVILMATERIALCATEGORY, onDeleteCivilAccountCategory);
}

export function* watchAddNewCivilAccountCategory() {
  yield takeEvery(ADD_NEW_CIVILMATERIALCATEGORY, onAddNewCivilAccountCategory);
}

function* civilAccountCategorySaga() {
  yield all([
    fork(watchGetCivilAccountCategory),
    fork(watchDeleteCivilAccountCategory),
    fork(watchUpdateCivilAccountCategory),
    fork(watchAddNewCivilAccountCategory)
  ]);
}

export default civilAccountCategorySaga;
